import { images } from '../constants/images';
import { PageRoutes } from './page-routes';
import { Page } from './pages-types';
import { MaghMelaPageContent } from './magh-mela.content';

export const paushPurnimaPage: Page = {
  title: 'home:dates.paush.title',
  subtitle: 'home:dates.paush.description',
  path: PageRoutes.paushPurnima,
  heroImage: images['paush-purnima-hero'],
  heroImageAlt: 'home:dates.paush.title',
  readingTime: 2,
  content: (
    <div className="flex flex-col gap-6">
      <p>
        Paush Purnima marks the full moon day in the month of Paush according to the Hindu
        lunar calendar. It presents a significant association with the Moon and is hence
        considered auspicious for taking a holy dip for purification, renewal, and overall
        cleansing of one&apos;s physical and inner self in the Ganges.
      </p>
      <p>
        It is also the most ideal day for one to seek blessings from the Hindu God of the
        Moon, Lord Chandra. Devotees observe a specific fast during on this day.
      </p>
      <MaghMelaPageContent dateId="paush" />
    </div>
  ),
  linkedPages: (s) => [
    s.getPageOrThrow(PageRoutes.makarSankranti),
    s.getPageOrThrow(PageRoutes.mudhouse),
  ],
};

export const makarSankrantiPage: Page = {
  title: 'home:dates.makar.title',
  subtitle: 'home:dates.makar.description',
  path: PageRoutes.makarSankranti,
  heroImage: images['makar-sankranti-hero'],
  heroImageAlt: 'home:dates.makar.title',
  readingTime: 3,
  content: (
    <div className="flex flex-col gap-6">
      <p>
        Makar Sankranti is one of the most auspicious days in the Hindu calendar, marking
        the sun&apos;s transition into the zodiac sign of Capricorn (Makara). This
        celestial event signifies the end of the winter solstice and the beginning of
        longer days.
      </p>
      <p>
        At Magh Mela, this day holds special significance as millions gather at the
        Triveni Sangam to take a holy dip in the sacred waters. The ritual bath on this
        day is believed to wash away sins and bring prosperity and good fortune.
      </p>
      <p>
        Devotees also perform various charitable acts and offer prayers to the sun god,
        Surya, expressing gratitude for the life-giving energy he provides.
      </p>
      <MaghMelaPageContent dateId="makar" />
    </div>
  ),
  linkedPages: (s) => [
    s.getPageOrThrow(PageRoutes.mauniAmavasya),
    s.getPageOrThrow(PageRoutes.mudhouse),
  ],
};

export const mauniAmavasyaPage: Page = {
  title: 'home:dates.mauni.title',
  subtitle: 'home:dates.mauni.description',
  path: PageRoutes.mauniAmavasya,
  heroImage: images['mauni-amavasya-hero'],
  heroImageAlt: 'home:dates.mauni.title',
  readingTime: 3,
  content: (
    <div className="flex flex-col gap-6">
      <p>
        Mauni Amavasya, also known as the &quot;King of Snans&quot;, is considered the
        most significant bathing day during Magh Mela. On this new moon day, devotees
        observe a vow of silence (mauna) and take a holy dip in the Ganges at the break of
        dawn.
      </p>
      <p>
        The spiritual power of this day is believed to be at its peak when celestial
        bodies align in a particularly auspicious configuration. Pilgrims believe that
        bathing on this day can liberate them from the cycle of birth and death.
      </p>
      <p>
        The practice of silence on this day symbolizes inner reflection and communion with
        the divine, allowing devotees to focus entirely on their spiritual journey without
        the distractions of worldly conversations.
      </p>
      <MaghMelaPageContent dateId="mauni" />
    </div>
  ),
  linkedPages: (s) => [
    s.getPageOrThrow(PageRoutes.basantPanchami),
    s.getPageOrThrow(PageRoutes.mudhouse),
  ],
};

export const basantPanchamiPage: Page = {
  title: 'home:dates.basant.title',
  subtitle: 'home:dates.basant.description',
  path: PageRoutes.basantPanchami,
  heroImage: images['basant-panchami-hero'],
  heroImageAlt: 'home:dates.basant.title',
  readingTime: 2,
  content: (
    <div className="flex flex-col gap-6">
      <p>
        Basant Panchami heralds the arrival of spring and is dedicated to Goddess
        Saraswati, the deity of knowledge, music, art, and wisdom. The festival is marked
        by devotees wearing yellow clothes, symbolizing the vibrant mustard flowers that
        bloom during this season.
      </p>
      <p>
        During Magh Mela, this day takes on added significance as pilgrims combine the
        worship of Goddess Saraswati with the sacred bath in the Ganges. Students and
        artists particularly revere this day, seeking blessings for success in their
        educational and creative pursuits.
      </p>
      <MaghMelaPageContent dateId="basant" />
    </div>
  ),
  linkedPages: (s) => [
    s.getPageOrThrow(PageRoutes.maghiPurnima),
    s.getPageOrThrow(PageRoutes.premiumTwinTent),
  ],
};

export const maghiPurnimaPage: Page = {
  title: 'home:dates.maghi.title',
  subtitle: 'home:dates.maghi.description',
  path: PageRoutes.maghiPurnima,
  heroImage: images['maghu-purnima-hero'],
  heroImageAlt: 'home:dates.maghi.title',
  readingTime: 2,
  content: (
    <div className="flex flex-col gap-6">
      <p>
        Maghi Purnima, the full moon day in the month of Magh, marks an important bathing
        date, especially for Kalpwasis—those who spend the entire month living on the
        banks of the Ganges in simple tents, following strict spiritual disciplines.
      </p>
      <p>
        For Kalpwasis, this day represents the culmination of their month-long penance.
        They complete their vows by taking a final holy dip and offering prayers, having
        lived a life of austerity, meditation, and daily rituals throughout the month.
      </p>
      <MaghMelaPageContent dateId="maghi" />
    </div>
  ),
  linkedPages: (s) => [
    s.getPageOrThrow(PageRoutes.mahaShivratri),
    s.getPageOrThrow(PageRoutes.mudhouse),
  ],
};

export const mahaShivratriPage: Page = {
  title: 'home:dates.maha.title',
  subtitle: 'home:dates.maha.description',
  path: PageRoutes.mahaShivratri,
  heroImage: images['maha-shivratri-hero'],
  heroImageAlt: 'home:dates.maha.title',
  readingTime: 3,
  content: (
    <div className="flex flex-col gap-6">
      <p>
        Maha Shivratri, the &quot;Great Night of Shiva&quot;, concludes the Magh Mela
        celebrations. This night is dedicated to Lord Shiva, one of the principal deities
        of Hinduism, representing transformation and regeneration.
      </p>
      <p>
        Devotees observe fasts and stay awake throughout the night, chanting mantras and
        performing rituals in honor of Lord Shiva. The darkest night of the month
        symbolizes overcoming darkness and ignorance through devotion and spiritual
        practice.
      </p>
      <p>
        At Magh Mela, this day sees elaborate ceremonies at Shiva temples along the
        Ganges, with devotees offering bilva leaves, milk, and water to Shiva lingams. The
        holy bath taken on this day is believed to bestow blessings of spiritual
        enlightenment and liberation.
      </p>
      <MaghMelaPageContent dateId="maha" />
    </div>
  ),
  linkedPages: (s) => [
    s.getPageOrThrow(PageRoutes.paushPurnima),
    s.getPageOrThrow(PageRoutes.premiumTwinTent),
  ],
};
